<template>
  <div v-bind='$attrs'>
    <label
      v-if='label'
      class='block text-sm font-medium text-gray-700'
    >
      <QuestionMarkCircleIcon
        v-if='help'
        class='question-mark-circle-icon mb-1 mr-0.5 inline-block h-4 w-4 cursor-pointer'
        @click='setHelpModalVisibility(true)'
      />
      {{ label }}
    </label>
    <div class='relative mt-1'>
      <div class='flex flex-row'>
        <div
          v-for='status in modelValue'
          :key='status.label'
        >
          <EmailStatusItem
            v-bind='status'
          />
        </div>
      </div>
    </div>
    <InputError :error='error'/>

  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import useInputFieldHasHelp, { InputFieldHasHelpProps, InputFieldHasHelpComponents } from '../../../compositions/useInputFieldHasHelp'
  import { InputFieldProps, InputFieldComponents } from '@/compositions/useInputFieldBase'
  import EmailStatusItem from './EmailStatusItem.vue'

  export default defineComponent({
    name: 'EmailStatusField',
    components: {
      ...InputFieldComponents,
      ...InputFieldHasHelpComponents,
      EmailStatusItem,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
    },
    setup() {
      const { helpVisible, setHelpModalVisibility } = useInputFieldHasHelp()

      return {
        helpVisible,
        setHelpModalVisibility,
      }
    },
  })
</script>
